<template>
  <div v-if="loadingResponse" v-html="htmlResponseUser">
  </div>
</template>

<script>

const _ = require('lodash');

export default {
  name: 'Response2020',
  data() {
    return {
      htmlResponseUser: '',
      loadingResponse: false,
    };
  },
  props: [
    'content',
  ],
  mounted() {
    this.getHtml();
  },
  methods: {
    getHtml() {
      let testTableName = false;
      let countQuestion = 1;
      this.htmlResponseUser = `<h1>${this.$t('response.title')}</h1>`;
      _.forEach(this.content, (item) => {
        if (_.get(item, 'question.answered')) {
          if (_.get(item, 'question.isStartTheme')) {
            this.htmlResponseUser += `<h2>${_.get(item, 'question.themeName')}</h2>`;
          }
          if (_.get(item, 'question.type') !== 'calculation') {
            if (_.get(item, 'question.isStartTable') || testTableName === true) {
              if (_.get(item, 'question.isStartTable')) {
                this.htmlResponseUser += `<p style="margin-bottom: 0;"><strong>${countQuestion}) ${_.get(item, 'question.tableName')}</strong>`;
                this.htmlResponseUser += '<ol style="padding: 0; margin: 0; list-style-type:disc">';
                countQuestion += 1;
              }
              if (typeof _.get(item, 'answer') === 'object') {
                this.htmlResponseUser += `<li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp; ${_.get(item, 'question.title')} : ${(_.get(item, 'answer[0].value'))}</li>`;
              } else if (typeof _.get(item, 'answer') === 'string') {
                this.htmlResponseUser += `<li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp; ${_.get(item, 'question.title')} : ${(_.get(item, 'answer'))}</li>`;
              }
              testTableName = true;
            } else {
              this.htmlResponseUser += `<p style="margin-bottom: 0;"><strong>${countQuestion}) ${_.get(item, 'question.title')}</strong>`;
              countQuestion += 1;
              if (typeof _.get(item, 'answer') === 'string') {
                this.htmlResponseUser += '<ol style="padding: 0; margin: 0; list-style-type: none;">';
                this.htmlResponseUser += `<li>${_.get(item, 'answer')}</li>`;
                this.htmlResponseUser += '</ol>';
              } if (typeof _.get(item, 'answer') === 'object') {
                this.htmlResponseUser += '<ol style="padding: 0; margin: 0;">';
                _.forEach(_.get(item, 'answer'), (a) => {
                  this.htmlResponseUser += `<li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp; ${a.value}</li>`;
                });
                this.htmlResponseUser += '</ol>';
              }
              this.htmlResponseUser += '</p>';
            }
            if (testTableName && _.get(item, 'question.isEndTable')) {
              testTableName = false;
              this.htmlResponseUser += '</ol></p>';
            }
          }
        }
      });
      this.loadingResponse = true;
    },
  },
};
</script>
